import { WarningIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoveAndAssignErrorOverlayMessage = ({
  message
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingInline: "100",
    gap: "25",
    children: [/*#__PURE__*/_jsx(WarningIcon, {}), message]
  });
};
MoveAndAssignErrorOverlayMessage.displayName = 'MoveAndAssignErrorOverlayMessage';
export default MoveAndAssignErrorOverlayMessage;